import { motion } from "framer-motion";
import { ArrowRight, MapPin, Clock } from "lucide-react";
import { CASE_STUDIES } from "@/data/content";

const port = "https://images.pexels.com/photos/14020705/pexels-photo-14020705.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function CaseStudies() {
  return (
    <section
      id="case-studies"
      data-testid="case-studies-section"
      className="border-b border-[#E4E7EC] bg-[#F9FAFB]"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="overline mb-4">§ 07 — Recent dockets</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
              Real shipments.<br />Real turnarounds.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#475467]">
              Anonymised dockets from the last operating quarter. Every case
              references the actual HAWB pattern, origin, cargo type, and time
              to out-of-charge or final delivery.
            </p>
            <div className="mt-8 hidden overflow-hidden border-2 border-[#101828] lg:block">
              <img
                src={port}
                alt="Container port at dusk — forwarder network partnerships"
                className="h-64 w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              {CASE_STUDIES.map((c, i) => (
                <motion.article
                  key={c.docket}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: i * 0.05 }}
                  className="bento-card flex flex-col border-2 border-[#101828] bg-white p-6"
                  data-testid={`case-${c.docket}`}
                >
                  <div className="flex items-center justify-between border-b border-dashed border-[#101828] pb-3">
                    <span className="font-mono-accent">{c.docket}</span>
                    <span className="font-mono-accent text-[#D92D20]">CLOSED</span>
                  </div>
                  <div className="mt-4 flex items-start gap-2 text-sm text-[#101828]">
                    <MapPin className="mt-0.5 h-4 w-4 flex-none text-[#D92D20]" strokeWidth={2.5} />
                    <span>
                      <strong>{c.origin}</strong>
                      <ArrowRight className="mx-2 inline h-3 w-3" strokeWidth={3} />
                      <strong>{c.destination}</strong>
                    </span>
                  </div>
                  <div className="mt-2 text-sm text-[#475467]">
                    Cargo: <span className="text-[#101828]">{c.cargo}</span>
                  </div>
                  <div className="mt-1 text-sm text-[#475467]">
                    Partner: <span className="text-[#101828]">{c.forwarder}</span>
                  </div>
                  <div className="mt-4 flex items-center gap-2 border-t border-[#E4E7EC] pt-4">
                    <Clock className="h-4 w-4 text-[#D92D20]" strokeWidth={2.5} />
                    <span className="font-display text-2xl font-black leading-none tracking-tight text-[#101828]">
                      {c.turnaround}
                    </span>
                    <span className="text-xs text-[#475467]">turnaround</span>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-[#475467]">
                    {c.outcome}
                  </p>
                </motion.article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
